<template>
  <div class="contract-wrap">
    <confirm-dialog
      :title="contractDialog.title"
      :confirm-text="contractDialog.confirmText"
      :dialog-width="contractDialog.width"
      :show.sync="contractDialog.show"
      :is-show="false"
      :is-show-close="false"
      @update:show="$emit('update:show', false)"
    >
      <span slot="content">
        <div>{{ msg }}</div>
        <div class="footer-box">
          <el-button size="small" @click="cancleBtn">返回工作台首页</el-button>
          <el-button v-if="confirmText=='联系客服'?false:true"
            type="primary"
            @click="goBtn(info)"
            size="small"
            >{{ confirmText }}</el-button
          >
        </div>
      </span>
    </confirm-dialog>

    <!-- 协议弹窗 倒计时 -->
    <confirm-dialog
      :title="ProDialog.title"
      :dialog-width="ProDialog.width"
      :show.sync="ProDialog.show"
      :is-show="false"
      :is-show-close="false"
      @handle-confirm="ProDialog"
      @update:show="crtTypeDialogUpdate"
      class="dialog_pay"
    >
      <span slot="content">
        <div style="overflow-y: hidden;">
          <div
            style="height:450px;overflow-y:scroll;"
            v-html="dialogInfo.htmlContent"
            id="box"
            ref="box"
          ></div>
        </div>
        <div class="check" style="padding: 20px 0;">
          <el-checkbox
            :disabled="btnDisabled"
            @@change="gxChecked"
            v-model="checked"
          ></el-checkbox>
          <span class="gx">我已详细阅读本协议，并同意协议</span>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex;justify-content: center;padding:30px;"
        >
          <el-button
            @click="ProCancelBtn"
            style="margin-right:20px;"
            size="small"
            >取 消</el-button
          >
          <el-button
            @click="conFrimBtn"
            :disabled="btnDisabled"
            :type="checked ? 'primary' : 'info'"
            size="small"
            >{{ btnText }}</el-button
          >
        </span>
      </span>
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "./ConfirmDialog.vue";

import { homeApiHr, UserUrl } from "@/assets/js/api.js";

export default {
  name: "ContractDialog",
  components: {
    ConfirmDialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isSuccess: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: {
      handler(val) {
        this.contractDialog.show = val;
      },
      deep: true
    }
  },
  data() {
    return {
      companyAuthInfo: {},
      contractDialog: {
        width: "400px",
        title: "提示",
        show: false
      },
      contractStatus: -1, //默认-1  模块协议状态 3 去续签 2 去签署 0 联系客服
      confirmText: "去签署",
      contactContentText: "", //弹窗内容
      // -----
      // 阅读协议弹窗
      ProDialog: {
        title: "",
        width: "835px",
        show: false
      },
      dialogInfo: {}, //协议弹出内容
      checked: false,
      btnText: "10s",
      countDownTime: 10,
      btnDisabled: false,
      busType: null,
      modelID: "",
      isAuthFlag: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    show:{
      handler(val){
        window.parent.postMessage({ headerOver:this.show},'*');
      },
      deep:true,
    }
  },
  computed: {
    msg: function (){
      if(this.confirmText == '去认证'){
        return '您的企业未进行认证，请完成认证后再尝试操作。';
      }else{
        return this.$store.state.statusInfo.msg;
      }
    },
    info: function (){
      if(this.confirmText == '去认证'){
        return this.companyAuthInfo;
      }else{
        return this.$store.state.statusInfo;
      }
    }
  },
  mounted() {},
  methods: {
    // 弹窗取消按钮
    cancleBtn() {
      let cancelArr = [
        "/smartEntry/TemplateSet",
        "/smartEntry/EnInvitateSet",
        "/smartEntry/EntryInfoFormSet",
        "/smartEntry/smartEntryPaidSupport"
      ];
      let currentStr = location.href.split("#")[1];
      console.log(cancelArr.includes(currentStr))
      if (cancelArr.includes(currentStr)) {
        this.$router.push("/smartEntry/SmartEntryIndex");
      } else {
        this.contractDialog.show = false;
        this.$emit("update:show", false);
        window.open(UserUrl+'/HrPlatform/Index','_top');
      }
    },
    // 弹窗确定按钮
    goBtn(obj) {
      // console.log(obj)
      // if (!obj.hasOwnProperty('processStatus') && obj.data.status == 0) {
      //   // 联系客服
      //   window.open(
      //     "https://www.echatsoft.com/visitor/pc/chat.html?companyId=12203&echatTag=website",
      //     "",
      //     "width=854,height=600,top=200,left=200"
      //   );
      // } else {
      //   // 协议的去签署、去续签都是跳转到同一个页面
      //   this.readSignBtn();
      // }
      // 协议的去签署、去续签都是跳转到同一个页面
      this.readSignBtn();
      this.contractDialog.show = false;
    },
    // 获取合同模板列表
    getList() {
      let _this = this;
      _this.$load("Get", _this.ApiUrl.reqGetModelBand, function(res) {
        if (res.data.isSuccess) {
          let list = res.data.data;
          list.forEach(item => {
            if (item.busType == 9) {
              // 智能入职
              _this.modelID = item.modelID;
            }
          });
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 弹出的取消按钮
    ProCancelBtn() {
      this.ProDialog.show = false;
    },
    // 设置从10s倒计时
    resetTime() {
      this.btnText = this.countDownTime + "s";
      this.time = setInterval(() => {
        this.countDownTime--;
        this.btnText = this.countDownTime + "s";
        if (this.countDownTime < 1) {
          window.clearInterval(this.time);
          this.btnText = `同意并开始使用${this.dialogInfo.modelName}`;
          this.btnDisabled = false;
        }
      }, 1000);
    },
    //  用户协议点击chengbox
    gxChecked(e) {
      this.checked = e;
    },
    // 监听关闭弹窗前的回调
    crtTypeDialogUpdate() {
      this.countDownTime = 10;
      this.$refs.box.scrollTop = 0;
      window.clearInterval(this.time);
    },
    // 阅读及签署(协议)
    async readSignBtn() {
      // 判断是否认证
      // 修改为判断是否进行了简易认证
      console.log(this.$store.state.userInfo)
      if (this.companyAuthInfo.data.processStatus != 3) {
        let status = this.companyAuthInfo.data.processStatus;
        let userID = this.$store.state.userInfo.userID;
        let url = UserUrl +`/GeneralPage/SimpleAuth?userId=${userID}&authState=${status}&url=userTask`;
        window.open(url,'_top');
      } else {
        this.ProDialog.show = true;
        let _this = this;
        this.$load("Get", this.ApiUrl.reqGetContract, function(res) {
          if (res.data.isSuccess) {
            _this.dialogInfo = res.data.data;
          } else {
            _this.$message.error(res.msg);
          }
        });
        // 弹出弹窗
        this.ProDialog.title = this.dialogInfo.modelName;
        this.btnDisabled = true;
        this.resetTime();
      }
    },
    async conFrimBtn() {
      let _this = this;
      if (!_this.checked)
        return _this.$message.warning("请勾选我已详细阅读协议，并同意协议按钮");
      // 签署阅读协议
      _this.$load(
        "Get",
        _this.ApiUrl.reqSignContract + "?modelId=" + _this.modelID,
        function(res) {
          console.log(res);
          if (res.data.isSuccess) {
            _this.$message.success(res.data.msg);
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            _this.$message.error(res.data.msg);
          }
        }
      );
      this.ProDialog.show = false;
    }
  }
};
</script>

<style>
.footer-box {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogBox/index.vue